// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';


// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import * as MuiPickers from '@material-ui/pickers';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import UpIcon from '@material-ui/icons/ArrowUpward';
import DownIcon from '@material-ui/icons/ArrowDownward';


import * as coreSelectors from '../core/selectors';
import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import * as ServiceIcons from './Icons';
import AddIcon from '@material-ui/icons/Add';

import OutlinedPopover from '../ui/OutlinedPopover';
// import PhoneTextField from '../ui/PhoneTextField';
import PhoneTextFieldWithFlag from '../ui/PhoneTextFieldWithFlag';
import { formatPhoneNumber } from '../ui/Formatters';

const styles = theme => ({
  /* Start/End time selector */
  timeSelector: {
  },
  popOverContainer: {
    padding: '15px 20px',
    '&.MuiPaper-root': {
      margin: 0
    }
  },
  callOptionsContainer: {
    margin: '0 0 10px 0',
    '& .MuiInputBase-input': {
      fontWeight: 500,
      fontSize: '14px'
    }
  },
  callOptionsLabel: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& .MuiButtonBase-root': {
      padding: '5px',
      marginLeft: '5px'
    },
  },
  iconButton: {
    padding: '5px',
    marginLeft: '5px'
  },
  popOverDialogue: {
    '& .MuiPaper-root': {
      margin: '10px',
      maxWidth: '540px'
    },
    [theme.breakpoints.up('sm')]: {
      padding: '32px'
    },
    [theme.breakpoints.up('md')]: {
      padding: '32px'
    },
  },
  callmeOptions: {
    // background:'red',
    display: 'flex',
    '& .MuiButtonBase-root': {
      padding: '0 1px'
    },
  }
});

/*
 * Default filler screen until the real one is implemented
 */

class Status extends Component {
  constructor (props) {
    super(props);
    this.durationSelectLabel = React.createRef();
    this.instructionSelectLabel = React.createRef();
    this.messageSelectLabel = React.createRef();
  }

  state = {
    durationLabelWidth : 0,
    instructionLabelWidth : 0,
    messageLabelWidth : 0,
    scheduleOverlap: false,
    scheduleOverlapMessage: '',
    menuOpen: false,
    menuElement: null
  }

  adjustLabels = () => {
    if (this.durationSelectLabel.current &&
        this.state.durationLabelWidth !== this.durationSelectLabel.current.offsetWidth) {
      this.setState({durationLabelWidth : this.durationSelectLabel.current.offsetWidth});
    }
    if (this.instructionSelectLabel.current &&
        this.state.instructionLabelWidth !== this.instructionSelectLabel.current.offsetWidth) {
      this.setState({instructionLabelWidth : this.instructionSelectLabel.current.offsetWidth});
    }
    if (this.messageSelectLabel.current &&
        this.state.messageLabelWidth !== this.messageSelectLabel.current.offsetWidth) {
      this.setState({messageLabelWidth : this.messageSelectLabel.current.offsetWidth});
    }
  }

  componentDidMount() {
    window.requestAnimationFrame(() => {
      this.adjustLabels();
    });
  }
  
  componentDidUpdate() {
    window.requestAnimationFrame(() => {
      this.adjustLabels();
    });
  }
    

  startNewStatus = () => {
    this.setState({gettingStatusType: true});
  }

  statusChange = (field, value) => {
    let newStatus = { ...this.props.status };
    if (typeof(value) === 'string' &&
        value.length > 100 &&
        field !== 'instructions') {
      return;
    }
    if (typeof(value) === 'string' &&
        value.length > 1000 &&
        field === 'instructions') {
      return;
    }

    if (field === 'saved' && value === true && newStatus.statusName === 'One Time') {
      newStatus.statusName = '';
    }
    if (field === 'saved' && value === false && newStatus.statusName === '') {
      newStatus.statusName = 'One Time';
    }

    if (field === 'messageCode') {
      newStatus.messageStatusListId = undefined;
    }
    if (field === 'instructionCode') {
      newStatus.instructionStatusListId = undefined;
    }
    if (field === 'durationCode') {
      newStatus.durationStatusListId = undefined;
    }
                                            
    newStatus[field] = value;
    this.props.setStatus(newStatus);

    /* Taking calls can make the window change size */
    if (field === 'takingCalls') {
      window.dispatchEvent(new Event("resize") );
    }
  }


  addName = (disposition) => {
    let exceptions = this.props.status.exceptions || [];
    if (exceptions.filter(exception => exception.disposition === disposition)
                  .length >= 5) {
      return;
    }
    let newId = 1;
    exceptions.forEach(exception => {
      if (typeof(exception.statusExceptionId) === 'string' &&
          exception.statusExceptionId.startsWith('n')) {
        let n = Number(exception.statusExceptionId.substring(1));
        if (n>=newId) {
          newId = n+1;
        }
      }
    });
    let status = { ...this.props.status,
                   exceptions : [ ...exceptions, {
                     statusExceptionId: 'n' + newId,
                     exceptionName: '',
                     disposition,
                   }]};
    this.props.setStatus(status);
    window.dispatchEvent(new Event("resize") );    
  }
  
  deleteName = (statusExceptionId) => {
    let exceptions = this.props.status.exceptions.filter(exception =>
      exception.statusExceptionId !== statusExceptionId);
    this.props.setStatus({ ...this.props.status, exceptions});
    window.dispatchEvent(new Event("resize") );    
  }
  
  changeName = (statusExceptionId, exceptionName) => {
    if (exceptionName.length > 100) {
      return;
    }
    let exceptions = this.props.status.exceptions.map(exception => {
      if (exception.statusExceptionId === statusExceptionId) {
        return({...exception, exceptionName});
      } else {
        return(exception);
      }
    });
    this.props.setStatus({ ...this.props.status, exceptions});
  }
  
  addContactNumber = (contactData) => {
    if (this.props.status.contacts.length >= 5) {
      return;
    }
    let newId = 1;
    let attemptOrder = 1;
    this.props.status.contacts.forEach(contact => {
      if (typeof(contact.statusContactId) === 'string' &&
          contact.statusContactId.startsWith('n')) {
        let n = Number(contact.statusContactId.substring(1));
        if (n>=newId) {
          newId = n+1;
        }
        if (contact.attemptOrder >= attemptOrder) {
          attemptOrder = contact.attemptOrder + 1;
        }
      }
    });
    let status = { ...this.props.status,
                   contacts : [ ...this.props.status.contacts, {
                     statusContactId: 'n' + newId,
                     contactMethod: 'PHONE',
                     contactData: contactData,
                     attemptOrder
                   }]};
    this.props.setStatus(status);
    window.dispatchEvent(new Event("resize") );    
    
  }

  changeContactNumber = (statusContactId, value) => {
    let contacts = [...this.props.status.contacts];
    let index = contacts.findIndex(contact => contact.statusContactId === statusContactId);
    contacts[index].contactData = value;
    this.props.setStatus({ ...this.props.status, contacts});
  }
  

  moveContactNumber = (statusContactId, up) => {
    let contacts = [...this.props.status.contacts];
    let index = contacts.findIndex(contact => contact.statusContactId === statusContactId);
     if (up) {
      contacts[index].attemptOrder--;
      contacts[index-1].attemptOrder++;
    } else {
      contacts[index].attemptOrder++;
      contacts[index+1].attemptOrder--;
    }
    contacts.sort((a, b) => a.attemptOrder - b.attemptOrder);
    this.props.setStatus({ ...this.props.status, contacts});
  }
  

  deleteContactNumber = (statusContactId) => {
    let attemptOrder = 0;
    let contacts = this.props.status.contacts
                       .filter(contact => contact.statusContactId !== statusContactId)
                       .map(contact => {
                         attemptOrder++;
                         return({...contact, attemptOrder});
                       });
    this.props.setStatus({ ...this.props.status, contacts});
    window.dispatchEvent(new Event("resize") );        
  }

  addStatus = (override, schedule) => {
    this.props.setStatusOpen(false);
    this.setState({scheduleOverlap: false});
    this.props.addStatus(this.props.status, override, schedule, (scheduleOverlapMessage) => {
      this.setState({scheduleOverlap : true, scheduleOverlapMessage});
    });
  }

  updateStatus = (override, schedule, scheduleId) => {
    this.props.updateStatus(this.props.status, schedule, override, scheduleId, (scheduleOverlapMessage) => {
      this.setState({scheduleOverlap : true, scheduleOverlapMessage});
    }, () => {
      this.props.setStatusOpen(false);
    });
  }
  
  editOverlap = () => {
    this.setState({scheduleOverlap: false});
    this.props.setStatusOpen(true);
  }
  
  render() {
    const { classes, status, statusOpen, setStatusOpen, statusSelectionLists, user} = this.props;

    /* Edit mode rather than add + schedule.  When editing all the
       schedule related fields are hidden  */
    let editing = Boolean(status.statusId);
    let contacts = user?.selfContact?.[0]?.contactMethods?.filter(contact => contact.contactMethodType === 'PHONE');

    

    let title = status.saved ? 'New Saved Status' : 'New One-Time Status';
    if (editing) {
      title = 'Editing "' + status.statusName + '"';
    }
    
    /* If a status is open with custom dates, do some verification on
       the dates in order to provide a feedback message */
    let timeWarnings='';
    if (!editing && statusOpen && status.durationCode === 'CUSTOM') {
      if (status.endTime !== null && status.startTime != null) {
        if (status.endTime.getTime() < status.startTime.getTime()) {
          timeWarnings='The end time is before the start time.';
        }
      }
      if (status.endTime !== null) {
        if (status.endTime.getTime() < Date.now()) {
          timeWarnings='The end time is in the past.';
        }
      }
    }
    if (!editing && statusOpen && status.startTime != null) {
      if (status.startTime.getTime() < Date.now()) {
        timeWarnings='The start time is in the past.';
      }
    }

    let numbersOkay = true;
    (status.contacts || []).forEach(contact => {
      if (Boolean(contact.contactData) && !contact.contactData.startsWith('+')) {
        numbersOkay = false;
      }});


    let icon = <ServiceIcons.TakeCallsIcon color='primary'/>;
    if (!status.takingCalls) {
      icon = <ServiceIcons.HoldCallsIcon color='primary'/>;
    }

    return (
      <React.Fragment>
        <MuiCore.Dialog open={this.state.scheduleOverlap}
                        maxWidth='xs'
                        onClose={() => this.setState({scheduleOverlap: false})}>
          <MuiCore.DialogTitle>
            Schedule Overlap
          </MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            <MuiCore.DialogContentText>
              {this.state.scheduleOverlapMessage}  Do you want to override with the new status schedule?
            </MuiCore.DialogContentText>
          </MuiCore.DialogContent>
          <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
            <MuiCore.Button onClick={() => this.addStatus(true, true)}>
              Override 
            </MuiCore.Button>
            <MuiCore.Button 
                            onClick={this.editOverlap}>
              Edit 
            </MuiCore.Button>
            <MuiCore.Button 
                            onClick={() => this.setState({scheduleOverlap: false})}>
              Cancel
            </MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>

        <OutlinedPopover
          classes={{
            root: classes.popOverContainer,
            popper: classes.popOverDialogue
          }} 
                          open={statusOpen}
                         title={title}
                         style={{fontFamily: 'Sofia-bold'}}
                         icon={icon}
                         maxWidth='xs'
                         onClose={() => setStatusOpen(false)}>
          <MuiCore.Grid container spacing={2}>
            
            <MuiCore.Grid item xs={12} sm={6}>
              <MuiCore.TextField
                fullWidth
                autoFocus
                onChange={(event) => this.statusChange('statusName', event.target.value)}
                value={status.statusName}
                InputLabelProps={{ shrink: true}}
                 label='Status name'
                placeholder="Status name"/>
            </MuiCore.Grid>

            <MuiCore.Hidden xlDown={true}>
              <MuiCore.Grid item xs={2} style={{ display: 'flex', alignItems : 'center'}}>
                <MuiCore.FormControlLabel
                  control={<MuiCore.Switch
                             checked={status.saved}
                                     onChange={(event) => this.statusChange('saved', event.target.checked)}/>}
                  label={'Save?'} />              
              </MuiCore.Grid>
            </MuiCore.Hidden>
            
            <MuiCore.Hidden>
              <MuiCore.Grid item xs={12} sm={6} >
                <MuiPickers.DateTimePicker
                  fullWidth
                  error={timeWarnings.length > 0}
                  className={classes.timeSelector}
                  InputLabelProps={{ shrink: true}}
                  clearable={true}
                  disablePast={true}
                  clearLabel='Now'
                  ampm={true}
                  format='MM/dd/yyyy hh:mm a'
                  minutesStep={5}
                  value={status.startTime}
                  onChange={(value) => this.statusChange('startTime', value ? value.toJSDate() : null)}
                  emptyLabel='Now'
                  label='Start Time'
                  placeholder='Start Time'/>
              </MuiCore.Grid>
            </MuiCore.Hidden>


            <MuiCore.Grid item xs={12} sm={6}>
              <MuiCore.Hidden>
                <MuiCore.FormControl fullWidth >
                  <MuiCore.InputLabel ref={this.durationSelectLabel}
                                      variant='outlined'>
                    {'Duration'}
                  </MuiCore.InputLabel>
                  <MuiCore.Select variant='outlined'
                                  onChange={(event) => this.statusChange('durationCode', event.target.value)}
                                  labelWidth={this.state.durationLabelWidth}
                                  value={status.durationCode}>
                    {(statusSelectionLists.durations || []).map((duration, index) => {
                      let list = [];
                      if (duration.code === 'DAY' || duration.code === 'NONE' ||
                          duration.code === 'CUSTOM') {
                        list.push(<MuiCore.Divider key={`divider-${index}`}/>);
                      }
                      list.push(<MuiCore.MenuItem key={duration.code}
                                                  value={duration.code}>
                        {duration.text}
                      </MuiCore.MenuItem>);
                      return(list);
                    })}
                  </MuiCore.Select>
                </MuiCore.FormControl>
              </MuiCore.Hidden>
            </MuiCore.Grid>
            
            <MuiCore.Hidden xlDown={editing && status.saved}>            
              <MuiCore.Grid item xs={12} sm={6}>
                <MuiCore.Hidden xlDown={status.durationCode !== 'CUSTOM'}>
                  <MuiPickers.DateTimePicker
                    error={timeWarnings.length > 0}
                    fullWidth
                    disabled={status.durationCode !== 'CUSTOM'}
                    className={classes.timeSelector}
                    InputLabelProps={{ shrink: true }}
                    clearable={true}
                    disablePast={true}
                    ampm={true}
                    minutesStep={5}
                    format='MM/dd/yyyy hh:mm a'
                    onChange={(value) => this.statusChange('endTime', value ? value.toJSDate() : null)}
                    value={status.endTime}
                    clearLabel='No End'
                    emptyLabel='Until Further Notice'
                    placeholder='Custom End Time'
                    label='Custom End Time'
                  />
                </MuiCore.Hidden>
                <MuiCore.Hidden xlDown={status.durationCode === 'CUSTOM'}>
                  <MuiCore.TextField fullWidth
                                     label='Custom End Time'
                                     disabled={true} value=''/>
                </MuiCore.Hidden>
              </MuiCore.Grid>
            </MuiCore.Hidden>

           {!!timeWarnings.length && <MuiCore.Grid item xs={12}>
              <MuiCore.Typography style={{fontFamily: 'Sofia', color: 'red', textAlign:'center'}}>{timeWarnings}</MuiCore.Typography>
            </MuiCore.Grid>}
            
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center',margin: "10px 0", width:'100%' }}>
            <MuiCore.Grid item xs={4} style={{ display: 'flex', alignItems: 'center', marginRight:'20px'}} >
              <MuiCore.Typography style={{fontFamily: 'Sofia'}}>
                Will you be taking calls?
              </MuiCore.Typography>
            </MuiCore.Grid>
            
            
            <MuiCore.Grid item xs={4}>
              <MuiCore.FormControlLabel
                control={<MuiCore.Switch
                           checked={status.takingCalls}
                                   onChange={(event) => this.statusChange('takingCalls', event.target.checked)}/>}
                label={status.takingCalls ? 'Yes' : 'No'} />              
            </MuiCore.Grid>
            </div>
           
            
            <MuiCore.Grid item xs={12}   style={{marginBottom: 10}}>
              <MuiCore.Typography color='#000' style={{fontFamily: 'Sofia-bold'}}>Advanced Options</MuiCore.Typography>
              <MuiCore.Divider/>
            </MuiCore.Grid>

            <MuiCore.Grid item xs={12} sm={6}>
              <MuiCore.Grid container spacing={2}>
                <MuiCore.Hidden xlDown={status.takingCalls}>
                  <MuiCore.Grid item xs={12}>
                    <MuiCore.FormControl fullWidth>
                      <MuiCore.InputLabel ref={this.messageSelectLabel}
                                          variant='outlined'>{"Tell Them..."}</MuiCore.InputLabel>
                      <MuiCore.Select variant='outlined'
                                      onChange={(event) =>
                                        this.statusChange('messageCode', event.target.value)}
                                      labelWidth={this.state.messageLabelWidth}
                                      value={status.messageCode}>
                        {(statusSelectionLists.messages || []).map(message => (
                          <MuiCore.MenuItem key={message.code}
                                            value={message.code}>
                            {message.text}
                          </MuiCore.MenuItem>                          
                         ))}
                      </MuiCore.Select>
                    </MuiCore.FormControl>
                  </MuiCore.Grid>
                </MuiCore.Hidden>

                <MuiCore.Hidden xlDown={status.takingCalls}>
                  <MuiCore.Grid item xs={12}>
                    <MuiCore.FormControl fullWidth>
                      <MuiCore.InputLabel ref={this.instructionSelectLabel}
                                          variant='outlined'>Instructions for the Agent</MuiCore.InputLabel>
                      <MuiCore.Select variant='outlined'
                                      onChange={(event) =>
                                        this.statusChange('instructionCode', event.target.value)}
                                      labelWidth={this.state.instructionLabelWidth}
                                      value={status.instructionCode}>
                        {(statusSelectionLists.instructions || []).map(instruction => (
                          <MuiCore.MenuItem key={instruction.code}
                                            value={instruction.code}>
                            {instruction.text}
                          </MuiCore.MenuItem>                          
                        ))}
                      </MuiCore.Select>
                    </MuiCore.FormControl>
                  </MuiCore.Grid>
                </MuiCore.Hidden>

                <MuiCore.Grid item xs={12}>
                  <MuiCore.TextField fullWidth
                                     value={status.instructions}
                                     onChange={(event) => this.statusChange('instructions', event.target.value)}
                                     multiline={true}
                                     inputProps={{ maxLength: 150 }}
                                     rows={2}
                                     label={`Extra Instructions (${150})`} />
                </MuiCore.Grid>
                
              </MuiCore.Grid>                
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12} sm={6}>
              <MuiCore.Grid container>
                <MuiCore.Hidden xlDown={!status.takingCalls}>
                  <MuiCore.Grid item xs={12}>
                    <MuiCore.Grid container className={classes.callOptionsContainer}>
                      <MuiCore.Grid item xs={12}
                      className={classes.callOptionsLabel}
                     >
                        <MuiCore.Typography variant='subtitle2'>
                          Not Accepting Calls From
                        </MuiCore.Typography>
                        <MuiCore.IconButton onClick={() => this.addName('REJECT')}>
                          <AddIcon/>
                        </MuiCore.IconButton>
                      </MuiCore.Grid>
                      {(status.exceptions || [])
                        .filter(exception => exception.disposition === 'REJECT')
                             .map(exception => (
                               <MuiCore.Grid key={exception.statusExceptionId} item
                                             style={{ display: 'flex'}}
                                             xs={12}>
                                 <MuiCore.TextField fullWidth
                                                    value={exception.exceptionName}
                                                    onChange={(event) => this.changeName(exception.statusExceptionId, event.target.value)}
                                                    variant='standard'/>
                                  {/* <PhoneTextFieldWithFlag variant='standard' value={exception.exceptionName} onlyCountries={['us']} onPhoneNumberChange={(change) => {
                                     this.changeName(exception.statusExceptionId, change)
                                   }}/> */}
                                 <MuiCore.IconButton
                                    className={classes.iconButton}
                                   onClick={() => this.deleteName(exception.statusExceptionId)}
                                   >
                                   <DeleteIcon color='#000'/>
                                 </MuiCore.IconButton>
                               </MuiCore.Grid>
                             ))}
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Hidden>

                <MuiCore.Hidden xlDown={status.takingCalls}>
                  <MuiCore.Grid item xs={12}>
                    <MuiCore.Grid container className={classes.callOptionsContainer}>
                      <MuiCore.Grid item xs={12} className={classes.callOptionsLabel}>
                        <MuiCore.Typography variant='subtitle2'>
                          Accepting Calls From
                        </MuiCore.Typography>
                        <MuiCore.IconButton onClick={() => this.addName('ACCEPT')}>
                          <AddIcon />
                        </MuiCore.IconButton>
                      </MuiCore.Grid>
                      {(status.exceptions || [])
                        .filter(exception => exception.disposition === 'ACCEPT')
                             .map(exception => (
                               <MuiCore.Grid key={exception.statusExceptionId} item
                                             style={{ display: 'flex'}}
                                             xs={12}>
                                 <MuiCore.TextField
                                   value={exception.exceptionName}
                                   onChange={(event) => this.changeName(exception.statusExceptionId, event.target.value)}
                                   fullWidth variant='standard'/>
                                   {/* <PhoneTextFieldWithFlag variant='standard' value={exception.exceptionName} onlyCountries={['us']} onPhoneNumberChange={(change) => {
                                     this.changeName(exception.statusExceptionId, change)
                                   }}/> */}
                                 <MuiCore.IconButton
                                   onClick={() => this.deleteName(exception.statusExceptionId)}
                                   style={{ marginLeft: 20, padding: 4 }}>
                                   <DeleteIcon color='#000'/>
                                 </MuiCore.IconButton>
                               </MuiCore.Grid>
                             ))}
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Hidden>

                <MuiCore.Grid item xs={12}>
                  <MuiCore.Grid item xs={12}>
                    <MuiCore.Grid container className={classes.callOptionsContainer}>
                      <MuiCore.Grid item xs={12}  className={classes.callOptionsLabel}>
                        <MuiCore.Typography variant='subtitle2'>
                          Call Me Here
                        </MuiCore.Typography>
                        <MuiCore.IconButton onClick={(event) => {
                          this.setState({menuOpen: true, menuElement: event.currentTarget})
                        }}>
                          <AddIcon/>
                        </MuiCore.IconButton>
                        <MuiCore.Menu
                          anchorEl={this.state.menuElement}
                          open={this.state.menuOpen}
                          onClose={() => {this.setState({menuOpen: false, menuElement: null})}}
                        >
                          {contacts?.map((contact, index) => (
                            <MuiCore.MenuItem key={contact?.contactId || index} onClick={() => {
                              this.addContactNumber(contact.phoneNumber); 
                              this.setState({menuOpen: false, menuElement: null})
                            }}>{contact.description}: {formatPhoneNumber(contact.phoneNumber)}</MuiCore.MenuItem>
                          ))}
                          <MuiCore.MenuItem onClick={() => {
                            this.addContactNumber(''); 
                            this.setState({menuOpen: false, menuElement: null})
                          }}>Add New Number</MuiCore.MenuItem>
                        </MuiCore.Menu>
                      </MuiCore.Grid>
                      {(status.contacts || [])
                        .map((contact, i) => (
                          <MuiCore.Grid 
                          key={contact.statusContactId}
                          item
                          style={{ display: 'flex'}}
                          xs={12}
                          >
                            <MuiCore.Grid style={{ width: '100%' }}>
                              <PhoneTextFieldWithFlag variant='standard' maxLength={11} value={contact.contactData} onlyCountries={['us']} onPhoneNumberChange={(change) => {
                                      this.changeContactNumber(contact.statusContactId, change)
                                    }}/>
                            </MuiCore.Grid>
                            <MuiCore.Grid className={classes.callmeOptions}>
                              <MuiCore.IconButton
                                onClick={() => this.moveContactNumber(contact.statusContactId, true)}
                                color='#000'
                                disabled={i === 0}
                                >
                                <UpIcon/>
                              </MuiCore.IconButton>
                              <MuiCore.IconButton
                                onClick={() => this.moveContactNumber(contact.statusContactId, false)}
                                color='#000'
                                disabled= {(i+1) === status.contacts.length}
                                >
                                <DownIcon/>
                              </MuiCore.IconButton>
                              <MuiCore.IconButton
                                onClick={() => this.deleteContactNumber(contact.statusContactId)}
                                >
                                <DeleteIcon color='#000'/>
                              </MuiCore.IconButton>
                            </MuiCore.Grid>
                          </MuiCore.Grid>
                        ))}
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                </MuiCore.Grid>
              </MuiCore.Grid>                
            </MuiCore.Grid>
            
            <MuiCore.Grid item xs={12} style={{textAlign: 'center',
                                               paddingTop: 10}}>
              <MuiCore.Hidden xlDown={editing}>
                <MuiCore.Grid container spacing={2} justify='center'>
                  <MuiCore.Grid item>
                    <MuiCore.Button onClick={() => this.addStatus(false, true)}
                                    disabled={!numbersOkay || timeWarnings.length > 0}>
                      Schedule Status
                    </MuiCore.Button>
                  </MuiCore.Grid>
                  {/* <MuiCore.Grid item>
                    <MuiCore.Button onClick={() => this.addStatus(false, false)}
                                    disabled={!status.saved || !numbersOkay || timeWarnings.length > 0}>
                      Save But Do Not Schedule
                    </MuiCore.Button>
                  </MuiCore.Grid> */}
                </MuiCore.Grid>
              </MuiCore.Hidden>
              
              <MuiCore.Hidden xlDown={!editing}>
                <MuiCore.Button onClick={() => { 
                  if(status.saved){
                    this.updateStatus(false, false, undefined, undefined);
                    return;
                  }
                  this.updateStatus(false, true, this.props.user.scheduledStatuses.filter(item => item.statusId === status.statusId)[0]?.statusScheduleId);
                  // if(new Date(status.startTime).getTime() < (new Date().getTime() + (5*60*1000)) && new Date(status.endTime).getTime() > new Date().getTime()){
                  //   this.props.postSnackMessage('error', 'Cannot edit an active status');
                  // } else {
                  //   // this.props.cancelStatus(status.statusId, this.props.user.scheduledStatuses.filter(item => item.statusId === status.statusId)[0].statusScheduleId);
                  //   // this.addStatus(false, true);
                  //   this.updateStatus(false, true, this.props.user.scheduledStatuses.filter(item => item.statusId === status.statusId)[0]?.statusScheduleId);
                  // }
                 
                }}
                                disabled={!numbersOkay}>
                  Update Status
                </MuiCore.Button>
              </MuiCore.Hidden>

              
            </MuiCore.Grid>
          </MuiCore.Grid>
        </OutlinedPopover>
        
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    status : serviceSelectors.getStatus(state),
    statusOpen : serviceSelectors.getStatusOpen(state),
    statusSelectionLists : serviceSelectors.getStatusSelectionLists(state),
  });
};

const mapDispatchToProps = {
  setStatus : serviceActions.setStatus,
  setStatusOpen : serviceActions.setStatusOpen,
  addStatus : serviceActions.addStatus,
  updateStatus : serviceActions.updateStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Status));

